import { Button, Drawer, Input, notification, Row } from 'antd'
import './DrawerSectionComments.style.less'

import { useEffect, useState } from 'react'

import { ArrowLeftOutlined, DoubleRightOutlined } from '@ant-design/icons'
import ChatIcon from '@/components/ChatIcon'
import SectionNameWithCommentCount from './SectionNameWithCommentCount/SectionNameWithCommentCount'
import { isEmptyValue } from '@/utils/common'
import Fade from '@/components/Fade'
import { eventBus } from '@/utils/eventBus'
import { REPORT_CONTROL_TYPES } from '../../InSpectionReport.constant'
import { MITT_EVENT_BUS } from '@/constant/common'
import {
  useGetSectionCommentListHook,
  useInspectionAddCommentHook,
} from '@/screens/QSF/Inspection/Inspection.hook'

import CommentListComponent from '@/components/CommentListComponent'

import {
  COMMENT_INSPECTION,
  COMMENT_INSPECTION_SUMMARY,
  COMMENT_SUB_SECTION,
  COMMENT_SECTION,
  INSPECTION_COMMENT_PARAM_TYPE,
  INSPECTION_COMMENT_PAYLOAD,
  REQUEST_REVISION,
} from '@/screens/QSF/Inspection/Inspection.constant'
import {
  capitalize,
  get,
  includes,
  isEmpty,
  map,
  size,
  startCase,
} from 'lodash'
import { InspectionStatus } from '@/constant/qsf'
import { useQuery } from 'react-query'

const { INSPECTION_REPORT_COMMENT } = MITT_EVENT_BUS
const { UNDER_REVIEW } = InspectionStatus

interface Props {
  dataInspection?: any
  sectionsData?: any
  handleRefreshReport?: any
}

function DrawerSectionComments(props: Props) {
  const { data: querySectionsData } = useQuery(
    ['QUERY_DATA_INSPECTION', props.sectionsData],
    () => {
      return props.sectionsData
    }
  )

  const [mouseOver, setMouseOver] = useState(false)
  const [stateComment, setStateComment] = useState(null)
  const [selectedSection, setSelectedSection] = useState({
    section: null,
    sectionIndex: null,
  })
  const [selectedSubSection, setSelectedSubSection] = useState({
    subSection: null,
    subSectionIndex: null,
  })

  const [selectedCheckpoint, setSelectedCheckpoint] = useState({
    checkpoint: null,
    checkpointIndex: null,
  })
  const [startInspectionSummary, setStartInspectionSummary] = useState(null)
  const [startOverallComments, setStartOverallComments] = useState(false)
  const [queryParamsGetComment, setQueryParamsGetComment] = useState(null)

  const [open, setopen] = useState(false)
  const [stateIsLoadingButton, setStateIsLoadingButton] = useState(false)

  const inspectionAddComment = useInspectionAddCommentHook()
  const {
    data: getSectionComments,
    refetch: refetchGetComment,
    isLoading: isGetCommentLoading,
  } = useGetSectionCommentListHook(queryParamsGetComment)

  const inspectionRound = get(props.dataInspection, 'round')

  const onBackSectionList = () => {
    setStartInspectionSummary(false)
    setStartOverallComments(false)
    setSelectedSection(null)
    setSelectedSubSection(null)
    setSelectedCheckpoint(null)
    onClearComment()
  }

  const onBackSubSection = () => {
    const section = get(selectedSubSection, 'subSection')
    const sectionIndex = get(selectedSubSection, 'subSectionIndex')

    const sectionData = {
      section,
      sectionIndex,
    }
    onClickSection(sectionData, COMMENT_SUB_SECTION)
    setSelectedCheckpoint(null)
    onClearComment()
  }

  const onBackSection = () => {
    const section = get(selectedSection, 'section')
    const sectionIndex = get(selectedSection, 'sectionIndex')

    const sectionData = {
      section,
      sectionIndex,
    }
    onClickSection(sectionData, COMMENT_SECTION)
    setSelectedSubSection(null)
    setSelectedCheckpoint(null)
    onClearComment()
  }
  const scrollToClass = () => {
    const el = document.querySelector('.section-comment-input-container')
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
      })
    }
  }

  // Scroll to the add comment section when select section/tasks (queryParamsGetComment changes)
  useEffect(() => {
    scrollToClass()
  }, [{ ...queryParamsGetComment }])

  useEffect(() => {
    eventBus.on(INSPECTION_REPORT_COMMENT, (data: any) => {
      const dataSection = get(data, 'selectedSection')
      const dataSubSection = get(data, 'selectedSubSection')
      const dataCheckpoint = get(data, 'selectedCheckpoint')

      if (!isEmptyValue(data)) {
        setSelectedSection(data.selectedSection)
        setSelectedSubSection(data.selectedSubSection)
        setSelectedCheckpoint(data.selectedCheckpoint)
        let type = null
        let sectionData = null

        if (data?.selectedSection?.section?.type === 'inspection_summary') {
          const section = {
            id: data.selectedSection?.section?.id,
          }
          const sectionIndex = 0
          sectionData = {
            section,
            sectionIndex,
          }
          type = 'inspection_summary'
        } else if (dataCheckpoint) {
          const { checkpoint, checkpointIndex } = dataCheckpoint
          sectionData = {
            section: checkpoint,
            sectionIndex: checkpointIndex,
          }
          type = 'checkpoint'
        } else if (dataSubSection) {
          const { subSection, subSectionIndex } = dataSubSection
          sectionData = {
            section: subSection,
            sectionIndex: subSectionIndex,
          }
          type = 'sub_section'
        } else if (dataSection) {
          const { section, sectionIndex } = dataSection
          sectionData = {
            section,
            sectionIndex,
          }
          type = 'section'
        }

        if (sectionData && type) {
          onClickSection(sectionData, type)
        }
      } else {
        setSelectedSection(null)
        setSelectedSubSection(null)
        setSelectedCheckpoint(null)
      }

      setopen(true)
    })

    return () => {
      eventBus.off(INSPECTION_REPORT_COMMENT)
    }
  }, [])

  const onSectionAddCommentFN = (
    commentType: typeof COMMENT_SUB_SECTION | typeof COMMENT_SECTION,
    value
  ) => {
    setStateIsLoadingButton(true)
    const payload: INSPECTION_COMMENT_PAYLOAD = {
      type: 'new',
      json_value: {
        comment: value?.value ?? '',
      },
      comment_type: COMMENT_SECTION,
      category: REQUEST_REVISION,
    }

    if (includes([COMMENT_SUB_SECTION], commentType)) {
      const { id }: any = selectedSubSection.subSection
      payload.section_id = id
      payload.comment_type = COMMENT_SUB_SECTION
    }

    if (includes([COMMENT_SECTION], commentType)) {
      const { id }: any = selectedSection.section
      payload.section_id = id
    }

    const params: INSPECTION_COMMENT_PARAM_TYPE = {
      inspectionId: props.dataInspection.id,
      payload,
    }

    inspectionAddComment.mutate(params)
  }

  const onNonSectionAddCommentFN = async (
    commentType: typeof COMMENT_INSPECTION | typeof COMMENT_INSPECTION_SUMMARY,
    value
  ) => {
    if (isEmpty(commentType)) {
      return
    }
    setStateIsLoadingButton(true)
    const payload: INSPECTION_COMMENT_PAYLOAD = {
      type: 'new',
      json_value: {
        comment: value?.value ?? '',
      },
      comment_type: commentType,
      category: REQUEST_REVISION,
    }

    const params: INSPECTION_COMMENT_PARAM_TYPE = {
      inspectionId: props.dataInspection.id,
      payload,
    }

    inspectionAddComment.mutate(params)
  }

  const onTaskAddCommentFN = (commentType: 'task', value) => {
    const { checkpoint } = selectedCheckpoint

    if (isEmpty(checkpoint)) {
      return
    }

    setStateIsLoadingButton(true)

    const payload: INSPECTION_COMMENT_PAYLOAD = {
      type: 'new',
      json_value: {
        comment: value?.value ?? '',
      },
      comment_type: commentType,
      category: REQUEST_REVISION,
      task_id: checkpoint.id,
    }

    const params: INSPECTION_COMMENT_PARAM_TYPE = {
      inspectionId: props.dataInspection.id,
      payload,
    }

    inspectionAddComment.mutate(params)
  }

  const onChangeComment = (event) => {
    const { name = '', value = '' } = event?.target
    setStateComment({ name, value })
  }

  const onClearComment = () => {
    setStateIsLoadingButton(false)
    setStateComment(null)
  }

  const handleOnFinishComment = async () => {
    await props.handleRefreshReport()
  }

  useEffect(() => {
    const { isError, error }: any = inspectionAddComment

    if (isError) {
      notification.error({
        message: error?.response?.data.message,
        duration: 3,
        placement: 'top',
      })
      setStateIsLoadingButton(false)
    }
  }, [inspectionAddComment.isError])

  useEffect(() => {
    if (inspectionAddComment.isSuccess) {
      onClearComment()
      handleOnFinishComment()
      refetchGetComment()
    }
  }, [inspectionAddComment.isSuccess])

  useEffect(() => {
    const isOpenSelect = document.querySelector('.ant-select-open')
    const allowScrolling = !mouseOver && !isOpenSelect
    if (allowScrolling) {
      document.body.style.overflow = 'auto'
    } else {
      document.body.style.overflow = ''
    }
  }, [mouseOver])

  const handleCloseModal = () => {
    setopen(false)
    onBackSectionList()
  }

  const onClickSection = (
    sectionData,
    type:
      | typeof COMMENT_SECTION
      | typeof COMMENT_SUB_SECTION
      | 'checkpoint'
      | 'inspection_summary'
      | 'inspection'
  ) => {
    if (!size(sectionData) || !size(sectionData?.section)) return

    const { section } = sectionData
    let commentType: string = COMMENT_SECTION
    if (type === COMMENT_SECTION) {
      setSelectedSection({
        section: sectionData.section,
        sectionIndex: sectionData.sectionIndex,
      })
    }

    if (type === COMMENT_SUB_SECTION) {
      commentType = COMMENT_SUB_SECTION
      setSelectedSubSection({
        subSection: sectionData.section,
        subSectionIndex: sectionData.sectionIndex,
      })
    }

    if (type === 'checkpoint') {
      commentType = 'task'
      setSelectedCheckpoint({
        checkpoint: sectionData.section,
        checkpointIndex: sectionData.sectionIndex,
      })
    }

    if (type === 'inspection') {
      commentType = 'inspection'
    }

    if (type === 'inspection_summary') {
      commentType = 'inspection_summary'
      setStartInspectionSummary(true)
    }

    const queryParams = {
      commentType,
      id: section?.id,
    }
    setQueryParamsGetComment(queryParams)
  }

  const handleRenderAddComment = (
    commentType: typeof COMMENT_INSPECTION | typeof COMMENT_INSPECTION_SUMMARY,
    isLoading: boolean = false
  ) => {
    const { status } = props.dataInspection

    if (includes([UNDER_REVIEW], status)) {
      return (
        <div className="section-comment-input-container">
          <Input.TextArea
            placeholder="Your comment..."
            autoSize
            value={stateComment?.value}
            onChange={onChangeComment}
            name="task"
          />
          <div className="input-separator" />
          <Row justify={'end'}>
            <Button
              loading={isLoading}
              type="primary"
              disabled={!size(stateComment?.value)}
              onClick={() => {
                onNonSectionAddCommentFN(commentType, stateComment)
              }}
            >
              Add Comment
            </Button>
          </Row>
        </div>
      )
    }

    return <></>
  }

  const handleRenderContent = () => {
    const summaryRound = get(props.dataInspection, 'inspection_summary_round')
    const overallRound = get(props.dataInspection, 'overall_comment_round')

    return (
      <Fade>
        <div className="section-name-container">
          <SectionNameWithCommentCount
            name="Overall Comments"
            commentCount={props.dataInspection.overall_comment_counter ?? 0}
            newUpdate={inspectionRound === overallRound}
            onClick={() => {
              const section = {
                id: props.dataInspection.id,
              }
              const sectionIndex = 0

              onClickSection(
                {
                  section,
                  sectionIndex,
                },
                'inspection'
              )
              setStartOverallComments(true)
            }}
          />
          <SectionNameWithCommentCount
            name="Inspection Summary"
            commentCount={props.dataInspection.inspection_summary_counter ?? 0}
            newUpdate={inspectionRound === summaryRound}
            onClick={() => {
              const section = {
                id: props.dataInspection.id,
              }
              const sectionIndex = 0

              onClickSection(
                {
                  section,
                  sectionIndex,
                },
                'inspection_summary'
              )
            }}
          />
          {map(querySectionsData, (section: any, sectionIndex: number) => (
            <SectionNameWithCommentCount
              onClick={() => {
                onClickSection(
                  {
                    section,
                    sectionIndex: sectionIndex,
                  },
                  COMMENT_SECTION
                )
              }}
              newUpdate={inspectionRound === section.round}
              key={section.name}
              name={`${sectionIndex + 1}. ${section.title}`}
              commentCount={section?.comment_with_children_counter ?? 0}
            />
          ))}
        </div>
      </Fade>
    )
  }

  const handleRenderSectionContent = () => {
    return (
      <Fade>
        <div>
          <Row onClick={onBackSectionList} className="back-section-button">
            <ArrowLeftOutlined />
            <p>Sections</p>
          </Row>
          <p className="selected-section-name">
            {`${selectedSection?.sectionIndex + 1}. ${
              selectedSection?.section?.title
            }`}
          </p>

          <CommentListComponent
            isLoading={isGetCommentLoading}
            inspectionRound={inspectionRound}
            dataSource={getSectionComments}
          />

          {includes([UNDER_REVIEW], props.dataInspection.status) && (
            <div className="section-comment-input-container">
              <Input.TextArea
                name="section"
                placeholder="Your comment..."
                autoSize
                onChange={onChangeComment}
                value={stateComment?.value}
              />
              <div className="input-separator" />

              <Row justify={'end'}>
                <Button
                  loading={stateIsLoadingButton}
                  type="primary"
                  disabled={!size(stateComment?.value) || isGetCommentLoading}
                  onClick={() => {
                    onSectionAddCommentFN(COMMENT_SECTION, stateComment)
                  }}
                >
                  Add Comment
                </Button>
              </Row>
            </div>
          )}

          <div className="sub-section-name-container">
            {selectedSection.section?.subSections?.map(
              (subSection, subSectionIndex) => {
                return (
                  <SectionNameWithCommentCount
                    onClick={() => {
                      onClickSection(
                        {
                          section: subSection,
                          sectionIndex: subSectionIndex,
                        },
                        COMMENT_SUB_SECTION
                      )
                      onClearComment()
                    }}
                    key={subSection.name}
                    newUpdate={inspectionRound === subSection.round}
                    name={`${selectedSection?.sectionIndex + 1}.${
                      subSectionIndex + 1
                    }. ${subSection.title}`}
                    commentCount={
                      subSection?.comment_with_children_counter ?? 0
                    }
                  />
                )
              }
            )}
          </div>
        </div>
      </Fade>
    )
  }
  const handleRenderSubSectionContent = () => {
    return (
      <div>
        <Row onClick={onBackSectionList} className="back-section-button">
          <ArrowLeftOutlined />
          <p>Sections</p>
        </Row>
        <p className="selected-section-name under-line" onClick={onBackSection}>
          {`${selectedSection?.sectionIndex + 1}. ${
            selectedSection?.section?.title
          }`}
        </p>
        <p className="selected-sub-section-name">
          {`${selectedSection?.sectionIndex + 1}.${
            selectedSubSection?.subSectionIndex + 1
          } ${selectedSubSection.subSection?.title}`}
        </p>

        <CommentListComponent
          isLoading={isGetCommentLoading}
          inspectionRound={inspectionRound}
          dataSource={getSectionComments}
        />

        {includes([UNDER_REVIEW], props.dataInspection.status) && (
          <div className="section-comment-input-container">
            <Input.TextArea
              placeholder="Your comment..."
              name="sub-section"
              autoSize
              value={stateComment?.value}
              onChange={onChangeComment}
            />
            <div className="input-separator" />

            <Row justify={'end'}>
              <Button
                type="primary"
                loading={stateIsLoadingButton}
                disabled={!size(stateComment?.value)}
                onClick={() => {
                  onSectionAddCommentFN(COMMENT_SUB_SECTION, stateComment)
                }}
              >
                Add Comment
              </Button>
            </Row>
          </div>
        )}

        <div className="sub-section-name-container">
          {selectedSubSection?.subSection?.checkpoints
            ?.filter(
              (checkpoint) =>
                checkpoint?.control_type == REPORT_CONTROL_TYPES.PHOTO
            )
            ?.map((checkpoint, checkpointIndex) => {
              const checkPointTitle = get(checkpoint, 'title')
              const checkPointName = get(checkpoint, 'name')
              const displayTitle =
                checkPointTitle || startCase(checkPointName) || 'Photo'

              return (
                <SectionNameWithCommentCount
                  onClick={() => {
                    onClickSection(
                      {
                        section: checkpoint,
                        sectionIndex: checkpointIndex,
                      },
                      'checkpoint'
                    )

                    onClearComment()
                  }}
                  key={checkpoint.name}
                  newUpdate={inspectionRound === checkpoint.round}
                  name={`• ${displayTitle}`}
                  commentCount={checkpoint?.comment_counter ?? 0}
                />
              )
            })}
        </div>
      </div>
    )
  }

  const handleRenderCheckpointContent = () => {
    const checkPointTitle = get(selectedCheckpoint, 'checkpoint.title')
    const checkPointName = get(selectedCheckpoint, 'checkpoint.name')
    const displayTitle =
      checkPointTitle || capitalize(startCase(checkPointName)) || 'Photo'

    return (
      <div>
        <Row onClick={onBackSectionList} className="back-section-button">
          <ArrowLeftOutlined />
          <p>Sections</p>
        </Row>
        <p className="selected-section-name under-line" onClick={onBackSection}>
          {`${selectedSection?.sectionIndex + 1}. ${
            selectedSection?.section?.title
          }`}
        </p>
        <p
          className="selected-sub-section-name under-line"
          onClick={onBackSubSection}
        >
          {`${selectedSection?.sectionIndex + 1}.${
            selectedSubSection?.subSectionIndex + 1
          } ${selectedSubSection.subSection?.title}`}
        </p>
        <p className="selected-sub-section-name">{`• ${displayTitle}`}</p>

        <CommentListComponent
          isLoading={isGetCommentLoading}
          inspectionRound={inspectionRound}
          dataSource={getSectionComments}
        />

        {includes([UNDER_REVIEW], props.dataInspection.status) && (
          <div className="section-comment-input-container scroll-checkpoint">
            <Input.TextArea
              placeholder="Your comment..."
              autoSize
              value={stateComment?.value}
              onChange={onChangeComment}
              name="task"
            />
            <div className="input-separator" />

            <Row justify={'end'}>
              <Button
                type="primary"
                loading={stateIsLoadingButton}
                disabled={!size(stateComment?.value)}
                onClick={() => {
                  onTaskAddCommentFN('task', stateComment)
                }}
              >
                Add Comment
              </Button>
            </Row>
          </div>
        )}
      </div>
    )
  }

  const handleRenderOverallCommentContent = () => {
    return (
      <div>
        <Row onClick={onBackSectionList} className="back-section-button">
          <ArrowLeftOutlined />
          <p>Sections</p>
        </Row>
        <p className="selected-section-name">Overall Comments</p>
        <CommentListComponent
          isLoading={isGetCommentLoading}
          inspectionRound={inspectionRound}
          dataSource={getSectionComments}
        />
        {handleRenderAddComment(COMMENT_INSPECTION, stateIsLoadingButton)}
      </div>
    )
  }
  const handleRenderInspectionSummaryContent = () => {
    return (
      <div>
        <Row onClick={onBackSectionList} className="back-section-button">
          <ArrowLeftOutlined />
          <p>Sections</p>
        </Row>
        <p className="selected-section-name">Inspection Summary</p>
        <CommentListComponent
          isLoading={isGetCommentLoading}
          inspectionRound={inspectionRound}
          dataSource={getSectionComments}
        />
        {handleRenderAddComment(
          COMMENT_INSPECTION_SUMMARY,
          stateIsLoadingButton
        )}
      </div>
    )
  }

  const handleRender = () => {
    if (startInspectionSummary) {
      return handleRenderInspectionSummaryContent()
    }

    if (startOverallComments) {
      return handleRenderOverallCommentContent()
    }

    if (!isEmptyValue(selectedCheckpoint)) {
      return handleRenderCheckpointContent()
    }

    if (!isEmptyValue(selectedSubSection)) {
      return handleRenderSubSectionContent()
    }

    if (!isEmptyValue(selectedSection)) {
      return handleRenderSectionContent()
    }

    return handleRenderContent()
  }

  return (
    <Drawer
      title=""
      placement={'right'}
      closable={false}
      open={open}
      key={'right'}
      width={500}
      onMouseOver={() => {
        setMouseOver(true)
      }}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="drawer-report-comment-container">
        <Button
          onClick={() => {
            handleCloseModal()
          }}
          className="button-close"
          type="text"
          icon={<DoubleRightOutlined className="close-icon" />}
        />
        <Row align={'middle'}>
          <span>
            <ChatIcon isWhite />
          </span>
          <p className="title">Comments</p>
        </Row>
        {handleRender()}
      </div>
    </Drawer>
  )
}

export default DrawerSectionComments
